import { render, staticRenderFns } from "./businesshospitalrelationship.vue?vue&type=template&id=2ff814b3&scoped=true&"
import script from "./businesshospitalrelationship.vue?vue&type=script&lang=js&"
export * from "./businesshospitalrelationship.vue?vue&type=script&lang=js&"
import style0 from "./businesshospitalrelationship.vue?vue&type=style&index=0&id=2ff814b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff814b3",
  null
  
)

export default component.exports